

<template>

    <v-card class="mx-auto"
            max-width="100%">
        <div id="divScanner" v-show="showScanner &&  !showLoading">

            <v-card-title>Scan Tubes  </v-card-title>

            <v-scandit v-if="scanninglicencekey.length" :license-key="scanninglicencekey"
                       :configuration-options="{ engineLocation: 'https://cdn.jsdelivr.net/npm/scandit-sdk@5.x/build/' }"
                       :scan-settings="{ enabledSymbologies: ['ean8', 'ean13', 'upca', 'upce','code128'] }"
                       v-on:scan="onScan" />


            <v-spacer></v-spacer>
            <br />

            <v-text-field type="text" v-model="scannedbarcode" label="Enter Barcode if unable to scan" />
            <v-spacer></v-spacer>
            <v-btn @click="getBarcodeData" color="primary" class="btn btn-block">GO</v-btn>
        </div>
        <v-flex xs10 class="mx-auto">
            <v-progress-circular model-value="20" v-show="showLoading">

            </v-progress-circular>
        </v-flex>
        <v-container v-show="!showScanner  && !showLoading && !(labeldata.patientId > 0)">
            <v-card>
                <v-alert style="color:red;">
                    {{labeldata.reason}}
                </v-alert>
            </v-card>
            <v-btn @click="scanMore" class="btn btn-block">Scan more</v-btn>
        </v-container>
        <v-container id="labelData" v-show="!showScanner  && !showLoading && labeldata.patientId > 0" style="padding:0px">
            <v-card-title style="text-align:center"><b>{{labeldata.patientName}}</b> </v-card-title>
            <v-card-text>
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col cols="3">
                                MRN
                            </v-col>
                            <v-col cols="auto">
                                <b>{{labeldata.labCheckPatientMrn}}</b>
                            </v-col>
                        </v-row>
                        <v-row v-show="formatDate(labeldata.dateOfBirth) != '01/01/0001'">
                            <v-col cols="3">
                                <label> DOB</label>
                            </v-col>
                            <v-col cols="auto">
                                <b>{{formatDate(labeldata.dateOfBirth)}}</b>
                            </v-col>

                        </v-row>
                        <v-row>
                            <v-col cols="3">Facility</v-col>
                            <v-col cols="auto">
                                <b> {{labeldata.facilityCd}} - {{labeldata.facilityName}} </b>
                            </v-col>
                        </v-row>
                        <v-row v-show="labeldata.clientLocation">
                            <v-col cols="3">Location</v-col>
                            <v-col cols="auto">
                                <b>{{labeldata.clientLocation }} </b>
                            </v-col>
                        </v-row>
                        <v-row v-show="labeldata.clientSite">
                            <v-col cols="3">Site</v-col>
                            <v-col><b>{{labeldata.clientSite }}</b></v-col>
                        </v-row>
                        <v-row v-show="labeldata.client">
                            <v-col cols="3">Client</v-col>
                            <v-col><b>{{labeldata.client }}</b></v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="3">Printed</v-col>
                            <v-col><b>{{formatDate(labeldata.scheduledCollectionDate)}}</b></v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="3">Actual</v-col>
                            <v-col><b>{{formatDateTime(labeldata.acutalCollectionDate)}} <label v-show="labeldata.timeZone">({{labeldata.timeZone}})</label></b> </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-card-text>
            <v-card-text>
                <v-card>
                    <v-row>
                        <v-col>
                            <v-alert style="color:red;" v-show="!labeldata.isCollectionDateEditable">
                                {{labeldata.reason}}
                            </v-alert>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-card-actions>
                                <v-btn color="primary"  @click="scanMore"  class=" ">Scan more</v-btn>                                
                            </v-card-actions>
                        </v-col>
                    </v-row>
                </v-card>

                <v-card id="DateContainer" v-show="labeldata.isCollectionDateEditable">
                    <v-card-text style="padding-top:0px">
                        <v-row align="center">
                            <v-col cols="auto" style="padding-bottom:20px;">
                                <label><b>Set Actual Collection Time</b></label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="3">
                                <v-select v-model="selectedColldate" id="ddCDate" :items="dateList" label="Date"> </v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="3">
                                <v-text-field v-model="selectedCollTime" id="ddCTime" type="time" style="width: fit-content" variant="underlined" label="Time"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="3">
                                <v-select v-model="selectedCollTimeZone" v-show="labeldata.isCollectionDateEditable" id="ddCtimezone" :items="timeZoneList" variant="underlined" label="Time Zone"> </v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-card-actions>
                                    <v-btn @click="scanMore" color="primary" class="btn btn-block">{{ collDateSuccessfullySaved ? 'Scan more' : 'Cancel' }}</v-btn>
                                    <v-btn color="primary" @click="setActucalCollectionDate" :disabled="!IsCollectionDateChanged" class="btn btn-block">Update Collection Time</v-btn>
                                </v-card-actions>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-alert style="color:green;" v-show="collDateSuccessfullySaved">
                                    <v-row><v-col cols="auto">Sucessfully updated Collection time.</v-col></v-row>

                                </v-alert>
                            </v-col>
                        </v-row>
                    </v-card-text>




            </v-card-text>
            <v-card-text v-show="Array.isArray(labeldata.resultTemplateItem)  &&  labeldata.resultTemplateItem.length > 0">
                <v-card>
                    <v-card-text style="padding-top:0px">
                        <v-row align="center">
                            <v-col cols="auto" style="padding-bottom:20px;">
                                <label><b>{{ResultTemplateHeading}}</b></label>
                            </v-col>
                        </v-row>
                        <v-row v-for="(rowItem, index) in labeldata.resultTemplateItem" :key="index">
                            <v-col cols="12" md="3">
                                <v-text-field v-model="rowItem.resultChar"
                                              :label="rowItem.labResultCdName"
                                              :placeholder="rowItem.labResultCdId"
                                              outlined></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-card-actions>
                                    <v-btn @click="scanMore" color="primary" class="btn btn-block">{{ resultDataSuccessfullySaved ? 'Scan more' : 'Cancel' }}</v-btn>
                                    <v-btn color="primary" @click="addUpdateResults" :disabled="!IsResultsChanged" class="btn btn-block">Update Results</v-btn>
                                </v-card-actions>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-alert style="color:green;" v-show="resultDataSuccessfullySaved">
                                    <v-row><v-col cols="auto">Sucessfully updated result.</v-col></v-row>

                                </v-alert>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-card-text>

            <v-card-text>
                <v-card>
                    <v-card-subtitle> ORDER DETAIL </v-card-subtitle>
                    <v-card-text style="padding-top:0px;">

                        <v-divider class="mx-4 mb-1"></v-divider>
                        <div v-for="(label) in labeldata.labels" :key="label.orderNumber">
                            <div style="font-weight:bolder;background-color:whitesmoke;display:inline">
                                {{ label.barCode }}
                            </div>
                            <div class="imagecontainer" :style="{
                             backgroundImage: 'url(' +'/assets/'+ label.tubeImageFileName + ')'}">

                            </div>

                            <div style="font-weight:bolder;">
                                <label v-for="testcode in csvToList(label.testList)" :key="testcode">
                                    {{testcode}}
                                </label>
                            </div>
                            <v-divider class="mx-4 mb-1"></v-divider>
                        </div>

                    </v-card-text>
                </v-card>
            </v-card-text>

        </v-container>
    </v-card>


</template>

<script>
    import labelService from "@/services/labelService";
    import resultsService from "@/services/resultsService";
    import moment from 'moment'



    export default {

        created() {
            labelService
                .getscansettings()
                .then(response => {
                    // Check for session timeout (401/403 or HTML response)
                    if (response.status === 401 || response.status === 403) {
                        throw new Error("SessionExpired");
                    }
                    const contentType = response.headers.get("content-type");
                    if (!contentType || !contentType.includes("application/json")) {
                        throw new Error("SessionExpired");
                    }
                    return response.json();
                })
                .then(data => {
                    this.scanninglicencekey = data.currentValue.licenseKey;
                })
                .catch((e) => {
                    if (e.message === "SessionExpired") {
                        this.$router.push("/login");
                    } else {
                        this.showScanner = true;
                        this.showLoading = false;
                        alert(e);
                    }
                });
        },

        name: "ScanTubes",
        data: function () {
            return {
                scannedbarcode: '',
                selectedColldate: '',
                selectedCollTime: '',
                selectedCollTimeZone: '',
                showScanner: true,
                showLoading: false,
                resultDataSuccessfullySaved: false,
                collDateSuccessfullySaved: false,
                dateList: [],
                hourList: [],
                minutesList: [],
                scanninglicencekey: "",
                labeldata: {
                    patientName: '',
                    patientId: '',
                    scheduledCollectionDate: '',
                    acutalCollectionDate: '',
                    patientOrderId: '',
                    sex: '',
                    dateOfBirth: '',
                    labCheckPatientMrn: '',
                    facilityCd: '',
                    facilityName: '',
                    labels: [],
                    resultTemplateItem: [],
                    orderStatusCdId: '',
                    isCollectionDateEditable: false,
                    reason: ''
                },
                originalColldate: '',
                originalCollTime: '',
                originalCollTimeZone: '',
                originalResultTemplateItem: []

            };
        },

        computed: {
            reason() {
                return this.dataList.reason;
            },
            timeZoneList() {
                return this.$store.state.timeZoneStore.timeZoneList;
            },
            ResultTemplateHeading() {
                return Array.isArray(this.labeldata.resultTemplateItem) && this.labeldata.resultTemplateItem.length > 0 ? this.labeldata.resultTemplateItem[0].resultTemplateName : "Enter Data";
            },
            IsCollectionDateChanged() {

                if (
                    this.selectedColldate !== this.originalColldate ||
                    this.selectedCollTime !== this.originalCollTime ||
                    this.selectedCollTimeZone !== this.originalCollTimeZone
                ) {
                    return true;
                }
                return false;
            },
            IsResultsChanged() {
                if (
                    Array.isArray(this.labeldata.resultTemplateItem) &&
                    Array.isArray(this.originalResultTemplateItem)
                ) {
                    if (this.labeldata.resultTemplateItem.length !== this.originalResultTemplateItem.length) {
                        return true;
                    }
                    for (let i = 0; i < this.labeldata.resultTemplateItem.length; i++) {
                        if (
                            this.labeldata.resultTemplateItem[i].resultChar !==
                            this.originalResultTemplateItem[i].resultChar
                        ) {
                            return true;
                        }
                    }
                }
                return false;
            },
            IsDataUpdated() {
                return this.IsCollectionDateChanged || this.IsResultsChanged;
            }
        },
        methods: {
            onScan(barcode) {
                this.scannedbarcode = barcode.barcodes[0].data;

                this.getBarcodeData();
            },
            onSubmit(e) {
                e.preventDefault();
                this.getBarcodeData();
            },
            getBarcodeData() {
                if (this.showLoading || !(this.showScanner)) {
                    return;
                }
                this.showLoading = true;

                if (!this.scannedbarcode)
                    alert('No barcode selected.')


                labelService
                    .getLabelData(this.scannedbarcode)
                    .then(response => {
                        // Check for session timeout (401/403 or HTML response)
                        if (response.status === 401 || response.status === 403) {
                            throw new Error("SessionExpired");
                        }
                        const contentType = response.headers.get("content-type");
                        if (!contentType || !contentType.includes("application/json")) {
                            throw new Error("SessionExpired");
                        }
                        return response.json();
                    })
                    .then(data => {
                        this.labeldata = data;
                        this.showScanner = false;
                        var facilityList = this.$store.state.facilityStore.facilityList;
                        var hasAccess = facilityList.some(item => item.facilityCd === this.labeldata.facilityCd);

                        this.showLoading = false;

                        if (!hasAccess) {

                            this.labeldata = {};
                            this.labeldata.isCollectionDateEditable = false;
                            this.labeldata.reason = 'Access denied';
                            return;
                        }
                        this.dateList = [];
                        for (let i = 0; i < 7; i++) {
                            var date = moment().subtract(i, 'days');
                            if (date > moment() || date > moment(this.labeldata.scheduledCollectionDate).add(7, 'days')) {
                                continue;
                            }
                            this.dateList.push(date.format("MM/DD/YYYY"));
                        }


                        this.selectedColldate = moment().format("MM/DD/YYYY");



                        this.selectedCollTime = moment().format("HH:mm");

                        try {
                            this.selectedCollTimeZone = new Date().toString().match(/\(([A-Za-z\s].*)\)/)[1];
                            if (this.selectedCollTimeZone == "Pacific Daylight Time") {
                                this.selectedCollTimeZone = "Pacific Standard Time";
                            }

                        } catch { this.timeZone = '' }



                        if (this.$store.state.timeZoneStore.timeZoneList.length == 0) {
                            labelService.getTimeZones().then(response => response.json())
                                .then(data => {
                                    this.$store.commit('timeZoneStore/setTimeZoneList', { timeZoneList: data });
                                });
                        }

                        this.resultDataSuccessfullySaved = false;
                        this.collDateSuccessfullySaved = false;
                        this.originalResultTemplateItem = JSON.parse(JSON.stringify(this.labeldata.resultTemplateItem));


                    })

                    .catch((e) => {
                        if (e.message === "SessionExpired") {
                            this.$router.push("/login");
                        } else {
                            this.showScanner = true;
                            this.showLoading = false;
                            alert(e);
                        }
                    });




            },
            setActucalCollectionDate() {

                this.showLoading = true;
                this.collDateSuccessfullySaved = false;

                const [hours, minutes] = this.selectedCollTime.split(':')

                var collDate = moment(this.selectedColldate, "MM/DD/YYYY");
                collDate = collDate.add(hours, 'hours');
                collDate = collDate.add(minutes, 'minutes');
                var tempSelectedCollDate = this.formatDateTime(collDate);

                labelService
                    .updateActualCollectionDate(this.labeldata.patientOrderId, this.labeldata.patientId, tempSelectedCollDate, this.selectedCollTimeZone)
                    .then(response => response.json())
                    .then(data => {

                        if (data == "SUCCESS") {
                            this.originalColldate = this.selectedColldate;
                            this.originalCollTime = this.selectedCollTime;
                            this.originalCollTimeZone = this.selectedCollTimeZone;

                        } else {
                            alert('Error setting Actual Collection date. Error:' + data);
                        }
                        this.collDateSuccessfullySaved = true;
                        this.showLoading = false;
                    })
                    .catch(() => {
                        alert('Error setting Actual Collection date');
                    });
            },
            addUpdateResults() {
                this.showLoading = true;
                this.resultDataSuccessfullySaved = false;

                var results = this.labeldata.resultTemplateItem.map(item => ({
                    LabResultCdId: item.labResultCdId,
                    ResultChar: item.resultChar
                }));

                resultsService.addUpdateResults(this.labeldata.patientOrderId, results)
                this.originalResultTemplateItem = JSON.parse(JSON.stringify(this.labeldata.resultTemplateItem));
                this.showLoading = false;
                this.resultDataSuccessfullySaved = true;

            },
            scanMore() {
                this.showScanner = true;
                this.scannedbarcode = '';
            },
            showBarcodeInputForm() {
                this.showScanner = false;
                this.scannedbarcode = '';
            },
            formatDate(value) {

                return moment(new Date(value)).format("MM/DD/YYYY");
            },
            formatDateTime(value) {

                return moment(new Date(value)).format("MM/DD/YYYY hh:mm A");
            },
            csvToList(csvstring) {
                return (csvstring != null) ? csvstring.split(',') : '';
            }
        }
    }

</script>
<style scoped>
    .v-progress-circular {
        display: block;
        width: 100px;
        margin: 0 auto;
    }

    .column {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .col, .col-auto {
        padding: 2px;
        margin: 0px;
    }

    button {
        padding: 5px 10px;
        font-size: small;
    }

    .dateContainer {
        display: flex;
        gap: 5px;
        font-size: small;
        width: 100%;
    }

    .v-text-field {
        padding: 1px;
        margin: 0px;
        font-size: 14px;
    }


    .v-select__selections {
        padding: 0px;
        max-width: 100%;
    }

    .v-select__selection--comma {
        margin: 0px;
        overflow: visible;
    }

    .imagecontainer {
        height: 50px;
        width: 250px;
        text-align: center;
        background-size: contain;
        box-sizing: border-box;
        display: block;
        border: 1px thin;
        top: 50%;
        left: 50%;
        padding: 10px;
    }
</style>